import { SVGProps, Ref, forwardRef } from 'react';

export const YandexCloudBrandSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M16 31c-3.727-.09-5.203-2.582-5.653-4.988-.245-1.308-.138-3.483 0-4.26.223-1.265.583-3.084.982-5.194.57-3.024 2.085-4.744 5.353-5.358l5.346-1.02c.142-.794.41-2.896.166-4.191-.455-2.433-2.33-4.95-6.134-4.989C7.773 1 1 7.713 1 16s6.713 15 15 15"
            fill="#9EB9FF"
        />
        <path
            d="M16 1c3.727.09 5.572 2.587 6.022 4.993.245 1.308-.231 3.479-.369 4.255-.223 1.265-.583 3.084-.982 5.194-.57 3.024-2.085 4.744-5.353 5.358l-4.975.977c-.142.793-.61 2.938-.365 4.233.455 2.432 2.157 4.951 5.962 4.99C24.227 31 31 24.287 31 16S24.287 1 16 1"
            fill="#5282FF"
        />
        <path
            d="M21.652 10.25c-.223 1.265-.582 3.083-.981 5.192-.57 3.024-2.085 4.744-5.354 5.358l-4.974.975.004-.023c.223-1.265.583-3.084.982-5.194.57-3.024 2.084-4.744 5.353-5.358z"
            fill="white"
        />
    </svg>
));
YandexCloudBrandSize32Glyph.displayName = 'YandexCloudBrandSize32Glyph';
